
namespace GeniuzPOS.Member {
    import fld = MbReport02_Row.Fields;
    @Serenity.Decorators.registerClass()
    export class MbReport02_Grid extends Serenity.EntityGrid<MbReport02_Row, any> {
        protected getColumnsKey() { return MbReport02_Columns.columnsKey; }
        protected getDialogType() { return MbReport02_Dialog; }
        protected getIdProperty() { return MbReport02_Row.idProperty; }
        protected getInsertPermission() { return MbReport02_Row.insertPermission; }
        protected getLocalTextPrefix() { return MbReport02_Row.localTextPrefix; }
        protected getService() { return MbReport02_Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions): any {
            let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            let columns = Object.keys(options.columnStyles)

            let descriptions: string[] = [];
            if (request?.Criteria) {
                let criteria = request.Criteria.toString().split(',');
                let key: string = criteria[0];

                let n = columns.find(n => {
                    return options.columnStyles[n]['field'] === key
                });
                if (n) {
                    key = options.columnStyles[n]['title'];
                }

                let d1 = criteria.findIndex(c => c == ">=");
                if (d1 >= 0) {
                    let v1 = criteria[d1 + 1];
                    let d2 = criteria.findIndex(c => c == "<");

                    if (d2 >= 0) {
                        let v2 = criteria[d2 + 1];

                        descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy" + ' (00:00)')}  -  ${Q.formatDate(v2, "dd/MM/yyyy" + ' (00:00)')}`);

                    } else {
                        descriptions.push(`${key}  ${Q.formatDate(v1, "dd/MM/yyyy")}`);
                    }
                } else {
                    let d2 = criteria.findIndex(c => c == "<");
                    if (d2 >= 0) {
                        let v2 = criteria[d2 + 1];
                        descriptions.push(`${key} ถึง  ${Q.formatDate(v2, "dd/MM/yyyy")}`);
                    }
                }
            } else {
                // descriptions.push("วันที่ = ไม่ระบุ");
            }



            console.log(request)
            if (request?.EqualityFilter) {
                let quickFilters = this.getQuickFilters();

                let filters = Object.keys(request.EqualityFilter);

                for (let filterCol of filters) {
                    let quickFilter = Q.first(quickFilters, x => x.field === filterCol);
                    let filterValue = request.EqualityFilter[filterCol];
                    // if else{
                    if (filterValue.length > 0) {
                        if (Array.isArray(filterValue)) {
                            if (quickFilter.options.lookupKey) {
                                // console.log(filterValue);
                                (filterValue as any[]).forEach(value => {
                                    var names: string[] = new Array(filterValue);
                                    for (var i = 0; i < names.length; i++) {
                                        filterValue = (names[i]);
                                        console.log(filterValue);
                                    }
                                })

                            }
                        } else {
                            filterValue
                        }
                    }
                    else {
                        filterValue = "ไม่ระบุ"
                    }
                    // }

                    let n = columns.find(n => {
                        return options.columnStyles[n]['field'] === filterCol
                    });
                    if (n) {  
                        if (filterValue != "ไม่ระบุ") {                                              
                                descriptions.push(`${options.columnStyles[n]['title']} = ${filterValue}`)
                            }
                        } else {                   
                        }
                }
            }
            return [descriptions, gridColumns];
        }
        // protected createQuickSearchInput() {
        // }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }
        // protected getViewOptions() {
        //     var opt = super.getViewOptions();
        //     opt.localSort = true;
        //     return opt;
        // }


        protected usePager() {
            return false;
        }


        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["MbType"]);
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.showFooterRow = true;
            opt.groupingPanel = true;

            return opt;
        }
        protected markupReady() {
            super.markupReady();
    
            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);
        }
        



        protected getButtons() {
            var buttons = super.getButtons();
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)
            buttons.filter(x => x.cssClass = "refresh-button")
            // Add buttons export excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: MbReport02_Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            


            let reportTitle = 'รายงานทะเบียนสมาชิกที่ใกล้หมดอายุ'

            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
               0: { field: "MbType", title: "ประเภทสมาชิก", isHidden:true },
               1: { field: "MemberTypeDesc", title: "ชื่อประเภทสมาชิก", isHidden:true },
                2: { field: "MbId", title: "รหัสสมาชิก", cellWidth: 47},
                
                3: { field: "MbNameT", title: "ชื่อสมาชิก", cellWidth: 80, overflow: 'linebreak' },
                4: { field: "MbNameE", title: "์Name", cellWidth: 80 , overflow: 'linebreak' },


                5: { field: "MbBirthDay", title: "ช่วงวันเกิด", isHidden:true },
                6: { field: "MbCardStatus", title: "สถานะบัตร", isHidden:true },

                7: { field: "MbAddress", title: "ที่อยู่", isHidden:true  },
                8: { field: "MbTumbol", title: "ตำบลแขวง", isHidden:true },
                9: { field: "MbAmphur", title: "อำเภอ/เขต", isHidden:true },
                10: { field: "MbProvince", title: "จังหวัด", isHidden:true },
                11: { field: "MbZipCode", title: "ไปรษณีย์", isHidden:true },
               12: { field: "MbNation", title: "สัญชาติ", isHidden:true },
                13: { field: "MbRace", title: "เชื้อชาติ", isHidden:true },
                14: { field: "MbOccupation", title: "อาชีพ", isHidden:true  },
                15: { field: "MbPid", title: "รหัสบัตรประชาชน", cellWidth: 40,halign: 'center' },
                16: { field: "MbApplyDate", title: "วันที่สมัคร", isHidden:true   },
                // 17: { field: "MbAccumPoint", title: "แต้มสะสม", cellWidth: 15, halign: 'right' },
                // 18: { field: "MbNearlyExpirePoint", title: "แต้มสะสมที่กำลังจะหมดอายุ", cellWidth: 20, halign: 'right' },
                // 19: { field: "MbExpirePointDate", title: "วันที่แต้มหมดอายุ", cellWidth: 20, halign: 'center' },
                17: { field: "MbExpireDate", title: "วันบัตรหมดอายุ", cellWidth: 40, halign: 'center' },
                18: { field: "MbGender", title: "ประเภทสมาชิก", isHidden:true },
                19: { field: "UpdateBy", title: "แก้ไขโดย", isHidden:true },
                20: { field: "LastUpdate", title: "วันที่แก้ล่าสุด", isHidden:true},
                21: { field: "MbTelNo", title: "เบอร์", cellWidth: 40, overflow: 'linebreak' ,halign: 'center'},
                22: { field: "MbEmail", title: "Email", cellWidth: 40, overflow: 'linebreak' ,halign: 'center'},
                // 15: { field: "GrossSales", title: "ยอดขายก่อนลด", cellWidth: 30, halign: 'right', aggregate: "sum" },
                // 16: { field: "AllItemDiscount", title: "ยอดส่วนลดทั้งหมด", cellWidth: 30, halign: 'right', aggregate: "sum" },
                // 17: { field: "NetSales", title: "ยอดขายสุทธิ", cellWidth: 30, halign: 'right', aggregate: "sum" },
                // 18: { field: "NetSalesExVat", title: "ยข. สุทธิหักVAT", cellWidth: 30, halign: 'right', aggregate: "sum" },
                // 19: { field: "VatOfNetSales", title: "VAT(ยอดขาย)", cellWidth: 30, halign: 'right', aggregate: "sum" },
                // 20: { field: "AllItemCharge", title: "ต่าชาร์จ", cellWidth: 30, halign: 'right', aggregate: "sum" },
                // 21: { field: "VatOfCharge", title: "VAT(ค่าชาร์จ)", cellWidth: 30, halign: 'right', aggregate: "sum" },


            }
            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            // buttons.push(GeniuzPOS.Common.Helpers.PdfExportHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     //separator: true,
               
            //     pageNumbers: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.Report1102PdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );

            return buttons;
        }

        // protected getQuickFilters() {
        //     var filters = super.getQuickFilters();

        //     Q.first(filters, x => x.field == fld.MbExpireDate).init = w => {

        //         (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());

        //         let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
        //         endDate.valueAsDate = new Date(new Date().setDate(new Date().getDate()+60));

        //         // endDate.valueAsDate = new Date(Date.now());
        //     };
        //     return filters;
        // }
       
    }
}